import {firestore, functions, httpsCallable} from "@/firebase/firebaseConfig";
import {doc, getDoc} from "firebase/firestore";
import {Voice} from "@/lib/types";

const availableVoices: Voice[] = []

const availableVoicesMap: Map<string, Voice> = new Map<string, Voice>()

export function extractVoicesToJSON(): Promise<void> {
    const voices = httpsCallable(functions, 'voices-extractVoices')
    return voices({})
        .then((result) => {
            console.log('Voices extracted successfully')
        })
        .catch((error) => {
            console.error('Error extracting voices', error)
        })
}

export async function getAvailableVoices(): Promise<Voice[]> {
    if (availableVoices.length > 0) {
        return Promise.resolve(availableVoices)
    }

    const docRef = doc(firestore, "Config", "GlobalConfig")
    return getDoc(docRef)
        .then((snapshot) => {
            if (snapshot.exists()) {
                const downloadURL = snapshot.data()?.availableVoices
                if (downloadURL) {
                    return fetch(downloadURL)
                        .then((response) => response.json())
                        .then((data: Record<string, Voice>) => {
                            if (Object.keys(data).length === 0) {
                                // Return an empty array if data is an empty object
                                return []
                            }
                            return Object.entries(data).map(([key, value]) => ({
                                id: key,
                                sourceId: value.sourceId,
                                countryCode: value.countryCode,
                                language: value.language,
                                gender: value.gender,
                                displayName: value.displayName,
                                sourceSystem: value.sourceSystem,
                                sample_url: value.sample_url,
                            } as Voice))
                        })
                        .catch((error) => {
                            console.error('Error fetching voice data', error)
                            return [] // Return an empty array in case of fetch error
                        })
                }
            }
            return [] // Return an empty array if downloadURL is not available
        })
        .catch((error) => {
            console.error('Error fetching available voices', error)
            return [] // Return an empty array in case of Firestore error
        }).then((voices) => {
            availableVoices.push(...voices)
            voices.forEach((voice) => {
                availableVoicesMap.set(voice.id, voice)
            })
            return voices
        })
}

export function getVoiceById(voiceId: string): Voice | null {
    if (availableVoicesMap.size === 0) {
        getAvailableVoices().then()
    }
    return availableVoicesMap.get(voiceId) || null
}